export default Object.freeze({
  DELETE: 'DELETE',
  CLEAR_RESPONSES: 'CLEAR_RESPONSES',
  ARCHIVE: 'ARCHIVE',
  DUPLICATE: 'DUPLICATE'
});
